import { Button, Col, Form, Input, Modal, Row, Select, Spin, message } from 'antd'
import React, { useEffect, useState } from 'react'
import { dadosSuporteService } from '../../services/Dados-Suporte-Service/dados-suporte-service'

interface ModalDadosSuporteProps {
    visible: boolean,
    fecharModal: Function
    modal: { ehEdicao: boolean, objeto: any | null, tabelaSelecionada: string }
    atualizarConsulta: Function

}

const ModalDadosSuporte: React.FC<ModalDadosSuporteProps> = (prop) => {

    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [campos, setCampos] = useState([]);
    const [objetoEdicao, setObjetoEdicao] = useState<any>(null)
    const limparForm = () => {
        form.resetFields();
    }

    useEffect(() => {
        limparForm()
        if (prop.modal.ehEdicao) {
            setObjetoEdicao(prop.modal.objeto)
            form.setFieldsValue({ tabela: prop.modal.tabelaSelecionada })
            carregarCampos(prop.modal.tabelaSelecionada)
            form.setFieldsValue({ ...prop.modal.objeto })
        }
    }, [prop.visible, prop.modal])

    const onFinish = async (values: any) => {
        if (prop.modal.ehEdicao) {
            setLoading(true);
            dadosSuporteService.put({
                ...objetoEdicao, ...values
            }, values.tabela)
                .then(() => {
                    message.success('Dado salvo com sucesso')
                    prop.fecharModal()
                    prop.atualizarConsulta()
                })
                .finally(() => {
                    setLoading(false);
                })
                .catch((err: any) => {
                    message.error(err?.response?.data?.error[0] || "Erro inesperado")
                })
        }
        else {
            setLoading(true);
            dadosSuporteService.post(values, values.tabela).then(() => {
                message.success('Dado salvo com sucesso')
                prop.fecharModal()
                prop.atualizarConsulta()
            })
                .finally(() => {
                    setLoading(false);
                })
                .catch((err: any) => {
                    message.error(err?.response?.data?.error[0] || "Erro inesperado")
                })
        }
    };


    const carregarCampos = (tabelaSelecionada: any) => {
        setLoading(true)
        dadosSuporteService.getPropertiesByTabela(tabelaSelecionada).then((resp) => {
            setCampos(resp.data)

        })
            .finally(() => {
                setLoading(false)
            })
    }

    const tabelasDadoSuporte = [{ tabela: 'escolaridade', descricao: 'Escolaridade' },
    { tabela: 'meioComunicacao', descricao: 'Meio Comunicacao' },
    { tabela: 'instituicaoEncaminhamento', descricao: 'Instituição de Encaminhamento' },
    { tabela: 'motivoEscolaridade', descricao: 'Motivo de Escolaridade' },
    { tabela: 'ocupacao', descricao: 'Profissional' }]

    const [valor, setValor] = useState('');

    function handleChange(event: any) {
        setValor(event.target.value);
    }

    return (
        <Modal
            visible={prop.visible}
            title="Dados Suporte"
            onCancel={() => prop.fecharModal()}
            footer={null}
        >
            <Form
                name="basic"
                form={form}
                // {...formItemLayout}
                onFinish={onFinish}
            >
                <Spin spinning={loading}>
                    <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                        <Col className="gutter-row" span={24} >
                            <Form.Item
                                label="Tipo do Dado Suporte"
                                name="tabela"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Por favor, selecione um tipo de dado!',
                                    }
                                ]}
                            >
                                <Select placeholder="Selecione" onChange={carregarCampos}
                                    disabled={prop.modal.ehEdicao}
                                >
                                    {tabelasDadoSuporte.map((t) => {
                                        return <Select.Option value={t.tabela}>{t.descricao}</Select.Option>
                                    })}
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    {campos.map((campo: any) => {
                        if (campo?.label != null) {
                            return <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                                <Col className="gutter-row" span={24} >
                                    <Form.Item
                                        label={campo?.label}
                                        name={campo?.formName}
                                        rules={[
                                            {
                                                required: true,
                                                message: campo?.formName === 'codigo' ? 'Por favor, insira um código, caso não haja coloque 0' :
                                                    'Por favor, insira um valor neste campo!',
                                            }
                                        ]}
                                    >

                                        {campo?.tipoCampo === 'SELECT' ?
                                            <Select placeholder="Selecione">
                                                {campo?.options?.map((option: any) => (
                                                    <Select.Option key={option?.value} value={option?.value}>
                                                        {option?.description}
                                                    </Select.Option>
                                                ))}
                                            </Select>
                                            :
                                            campo.formName === 'codigo' ? (
                                                <Input
                                                    placeholder="Insira um valor, se não houver, digite 0"
                                                    type="number"
                                                    maxLength={10}
                                                    value={valor}
                                                    onInput={(e) => {
                                                        const input = e.target as HTMLInputElement;
                                                        if (input.value.length > 10) {
                                                            input.value = input.value.slice(0, 10);
                                                        }
                                                    }}
                                                />
                                            ) : (
                                                <Input
                                                    placeholder="Insira um valor"
                                                    type="text"
                                                    value={valor}
                                                />
                                            )
                                        }


                                    </Form.Item>
                                </Col>
                            </Row>
                        }
                    })}
                    <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                        <Col span={24}>
                            <Form.Item>
                                <Button
                                    loading={loading}
                                    style={{ width: '100%' }} className="button-pre-cadastro" type="primary" htmlType="submit">
                                    Salvar
                                </Button>
                            </Form.Item>
                        </Col>
                    </Row>
                </Spin>
            </Form>
        </Modal >
    );
}

export default ModalDadosSuporte;